import { createFileRoute } from "@tanstack/react-router";
import AdminSurveyTopicNewPage from "@/pages/admin/surveys/detail/topics/new";
import { useSurveysPermissions } from "@/pages/admin/surveys";

export const Route = createFileRoute("/app/admin/surveys/$surveyId/topics/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { surveyId } = Route.useParams();
  const { userCanEditAllSurveys, userCanViewAllSurveys } = useSurveysPermissions();

  return (
    <AdminSurveyTopicNewPage
      surveyId={surveyId}
      userCanEditAllSurveys={userCanEditAllSurveys}
      userCanViewAllSurveys={userCanViewAllSurveys}
    />
  );
}
